import { render } from "./FileUpload.vue?vue&type=template&id=6601e3a6&scoped=true&ts=true"
import script from "./FileUpload.vue?vue&type=script&lang=ts"
export * from "./FileUpload.vue?vue&type=script&lang=ts"

import "./FileUpload.vue?vue&type=style&index=0&id=6601e3a6&scoped=true&lang=css"

import exportComponent from "D:\\Ventla Code\\New Admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6601e3a6"]])

export default __exports__